import API from "serviceshift-ui/api-client";

export default {
  createPart(_, { deptId, data }) {
    return API.parts.create(deptId, { part: data });
  },
  deletePart(_, { deptId, id }) {
    return API.parts.delete(deptId, id);
  },
  fetchPart(_, { deptId, id }) {
    return API.parts.get(deptId, id);
  },
  updatePart(_, { deptId, data }) {
    return API.parts.update(deptId, data.id, { part: data });
  },
  lookupPart(_, { search, id }) {
    return API.makeRequest(`/v2/departments/${id}/parts/search_part`, {
      method: "GET",
      contentType: "application/json",
      params: {
        "search[part]": search,
      },
    });
  },
  replacePart(_, { data, departId }) {
    return API.makeRequest(`/v2/departments/${departId}/parts/replace_part`, {
      method: "POST",
      data,
    });
  },
};
